import { ZeosSearchParamType } from "./Types";

export const qsMaker = (param: ZeosSearchParamType, value: string | number) => {
  return `${param}=${value}`;
};

export const getSearchParamTyped = <V>(
  param: ZeosSearchParamType,
  searchParams: URLSearchParams
) => {
  return searchParams.get(param as unknown as string) as unknown as V;
};

export const getIsBackPage = (searchParams: URLSearchParams): boolean => {
  return searchParams.get("mode") === "back";
};

export const getSearchParamNumber = (
  param: ZeosSearchParamType,
  searchParams: URLSearchParams
): number | undefined => {
  const v = searchParams.get(param as unknown as string);
  const n = v != null ? Number(v) : NaN;
  return Number.isFinite(n) ? n : undefined;
};
